import { SecurityGuard } from "@duosoftbg/nacid-components";
import ServiceConfigWrapperPage from "../views/pages/ServiceConfigWrapperPage";
import { libservAdditionalDocServiceConfig } from "../config/servicesConfig";
import React from "react";
import ServiceInfoPage from "../views/pages/ServiceInfoPage";
import LibservAdditionalDocNewPage from "../views/pages/additionalDoc/LibservAdditionalDocNewPage";

export const libservAdditionalDocRoutes = [
  {
    path: "/libserv-additional-doc",
    element: (
      <SecurityGuard doCheck={false}>
        <ServiceConfigWrapperPage serviceConfig={libservAdditionalDocServiceConfig} wrappedPage={<ServiceInfoPage />} />
      </SecurityGuard>
    ),
  },
  {
    path: "/libserv-additional-doc/new",
    element: (
      <SecurityGuard loginOnUnauthorized={true}>
        <ServiceConfigWrapperPage
          serviceConfig={libservAdditionalDocServiceConfig}
          wrappedPage={<LibservAdditionalDocNewPage />}
        />
      </SecurityGuard>
    ),
  },
];
